import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    Typography,
    // Button,
} from "@mui/material";
import StepWizard from "react-step-wizard";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import { DialogTitle } from "@material-ui/core";

import { useDispatch } from "react-redux";
import { clearWalkTestFormData } from "../../../store/actions/walkTestAction";
import ExitConfirmDialog from "../ExitConfirmDialog";
import VerifySleepDataWrapper from "./steps/verify-sleep-data/verify-sleep-data-wrapper";
import OtherInformationWrapper from "./steps/other-information/other-information-wrapper";
import ReviewAndGenerateReportWrapper from "./steps/review-and-generate/review-and-generate-report-wrapper";
import InlineErrorAlert from "./InlineErrorAlert";
import ModalCloseButton from "../../../components/UI/ModalCloseButton";
import {
    modalBackdropProps,
    MODAL_PAPER_SX,
} from "../../../utils/styles/modal.overlay";
import walkStyles from "../walkTestSecondStep.module.css";
import { sleepTheme } from "./sleepReportTheme";

const breadcrumbLabels = [
    "Verify Sleep Data",
    "Other information",
    "Review and Generate Report",
];

function SleepReportModal({
    open,
    onClose,
    devices,
    setReportGeneratedSuccessAlert,
    setSleepReportModalOpen,
    loadWaitingData,
    onSleepReportGenerated,
}) {
    const wizardInstance = React.useRef();

    const getWizardInstance = (instance) => {
        wizardInstance.current = instance;
    };

    const dispatch = useDispatch();
    const formikRef = React.useRef();

    const [formData, setFormData] = useState(null);
    const [reportData, setReportData] = useState(null);
    const [showExitConfirm, setShowExitConfirm] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [forceShowVerifiedToken, setForceShowVerifiedToken] = useState(0);

    const [alertDetails, setAlertDetails] = useState({
        message: "",
        severity: "error",
        showAlert: false,
    });

    const handleClose = () => {
        setShowExitConfirm(true);
    };

    useEffect(() => {
        if (open) {
            setCurrentStep(1);
            setForceShowVerifiedToken(0);
            // Always start with a fresh wizard state to avoid
            // reusing stale data from a previous generation flow.
            setFormData(null);
            setReportData(null);
            setAlertDetails({
                message: "",
                severity: "error",
                showAlert: false,
                autoClose: true,
            });
        }
    }, [open]);

    const handleConfirmExit = () => {
        if (formikRef.current) {
            formikRef.current.resetForm();
            formikRef.current.setSubmitting(false);
            formikRef.current.setTouched({});
        }
        setShowExitConfirm(false);
        setAlertDetails({
            message: "",
            severity: "error",
            showAlert: false,
            autoClose: true,
        });
        setFormData(null);
        // setOtherInfoData({
        //     odiDropPercentage: "",
        //     odiDropTime: "",
        //     percentageUpTo5: "",
        //     t1Score: "",
        //     t2Score: "",
        // });
        // setOtherInfoErrors({});
        dispatch(clearWalkTestFormData());
        onClose();
    };

    const getStepClassName = (stepNumber) => {
        if (currentStep === stepNumber) {
            return walkStyles.sleepStepLabelActive;
        }
        if (currentStep > stepNumber) {
            return walkStyles.sleepStepLabelCompleted;
        }
        return walkStyles.sleepStepLabelUpcoming;
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="lg"
                BackdropProps={modalBackdropProps}
                PaperProps={{
                    sx: {
                        ...MODAL_PAPER_SX,
                        colorScheme: "dark",
                        borderRadius: "4px",
                        width: "70%",
                        maxWidth: "95vw",
                        display: "flex",
                        flexDirection: "column",
                        maxHeight: "75vh",
                    },
                }}
            >
                <DialogTitle
                    style={{
                        padding: "24px 24px 0",
                        position: "sticky",
                        top: 0,
                        backgroundColor: sleepTheme.surface,
                        zIndex: 1,
                    }}
                >
                    <ModalCloseButton onClick={handleClose} />

                    <Typography
                        style={{
                            fontFamily: "Poppins",
                            fontSize: "20px",
                            fontWeight: 500,
                            color: sleepTheme.text,
                            marginBottom: "24px",
                            textAlign: "center",
                        }}
                    >
                        Sleep Report
                    </Typography>
                </DialogTitle>

                <DialogContent
                    className={walkStyles.walkTestModalContent}
                    style={{
                        paddingLeft: "100px",
                        paddingRight: "100px",
                        overflowY: "auto",
                        flex: 1,
                    }}
                >
                    {alertDetails.showAlert && (
                        <InlineErrorAlert
                            message={alertDetails.message}
                            severity={alertDetails.severity}
                            autoClose={alertDetails.autoClose !== false}
                            onClose={() =>
                                setAlertDetails({
                                    message: "",
                                    severity: "error",
                                    showAlert: false,
                                    autoClose: true,
                                })
                            }
                        />
                    )}

                    <div className={walkStyles.sleepStepper}>
                        <Breadcrumbs
                            separator={
                                <NavigateNextIcon
                                    fontSize="small"
                                    sx={{
                                        color: "rgba(255, 255, 255, 0.5)",
                                        verticalAlign: "middle",
                                    }}
                                />
                            }
                            aria-label="breadcrumb"
                            sx={{
                                "& .MuiBreadcrumbs-ol": {
                                    flexWrap: "wrap",
                                },
                                "& .MuiBreadcrumbs-separator": {
                                    color: "rgba(255, 255, 255, 0.5)",
                                },
                            }}
                        >
                            {breadcrumbLabels.map((label, idx) => {
                                const stepNumber = idx + 1;
                                return (
                                    <Typography
                                        key={label}
                                        component="span"
                                        className={getStepClassName(stepNumber)}
                                    >
                                        {label}
                                    </Typography>
                                );
                            })}
                        </Breadcrumbs>
                    </div>
                    <div>
                        <StepWizard
                            transitions={{}}
                            isLazyMount={true}
                            instance={getWizardInstance}
                            initialStep={1}
                            onStepChange={({ activeStep }) =>
                                setCurrentStep(activeStep)
                            }
                        >
                            <VerifySleepDataWrapper
                                devices={devices}
                                forceShowVerifiedToken={forceShowVerifiedToken}
                                formData={formData}
                                setFormData={setFormData}
                                onNextStep={(data) => {
                                    setFormData(data);
                                    wizardInstance.current?.nextStep();
                                }}
                                setAlertDetails={setAlertDetails}
                            />
                            <OtherInformationWrapper
                                onBack={() => {
                                    setForceShowVerifiedToken((prev) => prev + 1);
                                    wizardInstance.current?.previousStep();
                                }}
                                formData={formData}
                                setAlertDetails={setAlertDetails}
                                onNextStep={(values) => {
                                    // Persist selected ODI/T1/T2 values in the shared `formData`
                                    // so they can be shown again when navigating back.
                                    setFormData?.((prev) => ({
                                        ...(prev ?? {}),
                                        ...(values ?? {}),
                                    }));
                                    wizardInstance.current?.nextStep();
                                }}
                                setReportData={setReportData}
                            />
                            <ReviewAndGenerateReportWrapper
                                formData={formData}
                                devices={devices}
                                onBack={() =>
                                    wizardInstance.current?.previousStep()
                                }
                                reportData={reportData?.data}
                                setAlertDetails={setAlertDetails}
                                reportId={reportData?.report_id}
                                setReportGeneratedSuccessAlert={
                                    setReportGeneratedSuccessAlert
                                }
                                setSleepReportModalOpen={
                                    setSleepReportModalOpen
                                }
                                loadWaitingData={loadWaitingData}
                                onSleepReportGenerated={onSleepReportGenerated}
                            />
                        </StepWizard>
                    </div>
                </DialogContent>
            </Dialog>

            <ExitConfirmDialog
                open={showExitConfirm}
                onClose={() => setShowExitConfirm(false)}
                onConfirm={handleConfirmExit}
            />
        </>
    );
}

export default SleepReportModal;
